import { SERIES_COLORS } from './chart.consts';

export const getRepeatedColorByIndex = (index: number): string => {
  return SERIES_COLORS[index % SERIES_COLORS.length];
};
